import React from 'react';

import Td from './Td';
import { tiposSolicitacoesEnum } from '../../../../solicitacao.utils';
import IntlMessage from '../../../../../../helpers/intlMessage';

const Table = ({ item }) => (
  <table style={{ width: '100%', marginBottom: '7px' }}>
    <tbody>
      <tr>
        <Td
          title={<IntlMessage id="general.requestsPanel.identifier" />}
          value={item.id}
          styleTd={{ width: '200px' }}
        />
        <Td title={<IntlMessage id="general.requestsPanel.exam" />} value={item.nrExame} styleTd={{ width: '200px' }} />
        <Td title={<IntlMessage id="general.requestsPanel.type" />} value={item.tipo} styleTd={{ width: '200px' }} />
        <Td styleTd={{ width: '200px' }} title='Status' value={item.status} />
        <Td
          title={<IntlMessage id="general.requestsPanel.requestDate" />}
          value={item.dataCadastro}
          styleTd={{ width: '200px' }}
        />
      </tr>
      <tr>
        {item.tipoEnum === tiposSolicitacoesEnum.NOVO_CORTE && (
          <Td
            title={<IntlMessage id="general.requestsPanel.bottle" />}
            value={item.frasco}
            styleTd={{ width: '200px' }}
            colSpan='2'
          />
        )}
        {item.tipoEnum === tiposSolicitacoesEnum.APROFUNDAMENTO && (
          <Td
            title={<IntlMessage id="general.requestsPanel.block" />}
            value={item.bloco}
            styleTd={{ width: '200px' }}
            colSpan={item.coloracoes ? 1 : 2}
          />
        )}
        {item.tipoEnum === tiposSolicitacoesEnum.APROFUNDAMENTO &&
          item.coloracoes && (
            <Td
              title={<IntlMessage id="general.requestsPanel.colorations" />}
              value={item.coloracoesFormated}
              styleTd={{ width: '200px' }}
            />
          )}
        <Td
          title={<IntlMessage id="general.requestsPanel.colorations" />}
          value={item.usuarioSolicitante}
          styleTd={{ width: '200px' }}
        />
        <Td
          title={<IntlMessage id="general.requestsPanel.requester" />}
          value={item.usuarioExecutante}
          styleTd={{ width: '200px' }}
        />
        <Td
          title={<IntlMessage id="general.requestsPanel.dateOfChange" />}
          value={item.dataAlteracao}
          styleTd={{ width: '200px' }}
        />
      </tr>
      <tr>
        <Td colSpan='5' title={<IntlMessage id="general.requestsPanel.comment" />} value={item.comentario} />
      </tr>
    </tbody>
  </table>
);

export default Table;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/Relatorio/Impressao/Table/index.js